import React, { Component } from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';

class Alert extends Component {
  render() {
    return (
      <div className="custom-ui">
        <h1>Are you sure?</h1>
        <p>You want to delete this {this.props.name}?</p>
        <button onClick={this.props.onClose}>No</button>
        <button onClick={this.props.onDelete}>Yes, Delete!</button>
      </div>
    );
  }
}

export default Alert;
